import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbTokenStorage } from '@nebular/auth';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CurrentMemberProvider } from '../../auth/services/current-member-provider.service';

@Injectable()
export class HttpExternalTokenInterceptor implements HttpInterceptor {

  readonly endpointsThatRequireAuthentication = [
    environment.exchangeApi.url,
    environment.mediaUrl,
  ];

  constructor(
    private tokenStorage: NbTokenStorage,
    private currentMemberProvider: CurrentMemberProvider,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.currentMemberProvider.isInternal() && this.urlRequiresAuthorization(request.url)) {
      const headersConfig = {};
      const bearer = this.getExternalToken();

      headersConfig['Authorization'] = `Bearer ${bearer}`;

      request = request.clone({setHeaders: headersConfig});
    }

    return next.handle(request);
  }

  private getExternalToken(): string {
    let accessToken = 'none';
    const token = this.tokenStorage.get();

    if (token.getPayload() !== null) {
      accessToken = token.getPayload().access_token ? token.getPayload().access_token : token.toString();
    }

    return accessToken;
  }

  private urlRequiresAuthorization(url: string) {
    for (const endpoint of this.endpointsThatRequireAuthentication) {
      if (url.includes(endpoint)) {
        return true;
      }
    }

    return false;
  }
}
